// Bottom-center pill that surfaces the user's running vote tally during
// the `vote` phase. Helps participants know when they've used their budget
// without having to count dots across the board.
//
// Subscribes to the votes Y.Map via a parent hook (useVotesUsed); the pill
// itself is presentational.

import { CircleDot } from 'lucide-react';

interface Props {
  used: number;
  budget: number;
}

export function VoteBudgetPill({ used, budget }: Props) {
  const remaining = Math.max(0, budget - used);
  const exhausted = remaining === 0;

  return (
    <div
      role="status"
      aria-live="polite"
      className="
        inline-flex items-center gap-2 h-8 px-3
        bg-bg-panel border border-border-default rounded-full shadow-sm
        text-13 font-medium
      "
    >
      <CircleDot
        size={14}
        strokeWidth={1.75}
        className={exhausted ? 'text-fg-tertiary' : 'text-accent'}
      />
      <span className="tabular-nums text-fg-primary">
        {remaining} / {budget}
      </span>
      <span className="text-fg-secondary">
        {remaining === 1 ? 'vote left' : 'votes left'}
      </span>
    </div>
  );
}
